import React from "react"
import { Container } from "react-bootstrap"
import { OneDeliveryorderdetails2 } from "../../Components/Admin/oneDeliveryOrder2"
const AdminoneDeliveryorderdetailsPage2 = () => {
  return (
    <Container fluid>
      <OneDeliveryorderdetails2 />
    </Container>
  )
}
export default AdminoneDeliveryorderdetailsPage2
